const HomeMain: React.FC = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
export default HomeMain;
